import React from 'react';
import { Switch, Route } from 'react-router-dom';
import InvoicesList from './Invoices/InvoicesList';

const Routes = (): React.JSX.Element => (
  <Switch>
    <Route exact path="/invoices">
      <InvoicesList />
    </Route>
    <Route exact path="/statements/invoices">
      <InvoicesList />
    </Route>
  </Switch>
);

export default Routes;
